import axios from 'axios';
import { API_HOST } from '../../../consts';

export const fetchTemplates = () => (
  axios.get(`${API_HOST}/export_item/templates`)
    .then(response => response.data)
);

export default fetchTemplates;
